import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Filter1Icon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_1"}/>
}
